window._ = require('lodash');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

const reverbHost = process.env.MIX_REVERB_HOST || window.location.hostname;
const reverbPortEnv = process.env.MIX_REVERB_PORT ? parseInt(process.env.MIX_REVERB_PORT) : null;
const reverbScheme = process.env.MIX_REVERB_SCHEME || (window.location.protocol === 'https:' ? 'https' : 'http');

const isLoopback = ['localhost', '127.0.0.1'].includes(reverbHost);
const forceTLS = isLoopback ? false : (reverbScheme === 'https');
const reverbPort = Number.isFinite(reverbPortEnv) ? reverbPortEnv : (forceTLS ? 443 : 80);

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.MIX_REVERB_APP_KEY,
    wsHost: reverbHost,
    wsPort: reverbPort,
    wssPort: reverbPort,
    forceTLS: forceTLS,
    disableStats: true,
    enabledTransports: forceTLS ? ['wss', 'ws'] : ['ws'],
});
